import { render, staticRenderFns } from "./DeviceDetails.vue?vue&type=template&id=37db498c&"
import script from "./DeviceDetails.vue?vue&type=script&lang=ts&"
export * from "./DeviceDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports